import { useEffect, useState } from 'react'
import { TableController } from '../../../components/Constant'
import { useTranslation } from 'react-i18next'
import { CLIENT_BOOKING_LIST } from '../../../repository/client_management_repo'
import { useNavigate, useParams } from 'react-router-dom'
import useReduxStore from '../../../hooks/useReduxStore'

export default function useBooking() {
  const { t } = useTranslation()
  const [loader, setLoader] = useState(false)
  const [bookigdata, setBookingData] = useState([])
  const [totalCount, setTotalCount] = useState(10)
  // const navigate = useNavigate();
  const { id } = useParams()
  const { selector: user } = useReduxStore('auth')

  const [openModal, setOpenModal] = useState({
    addTeammember: false,
    viewBooking: false,
    deleteTeamMember: false,
    filter: false,
    data: null,
  })
  const [controller, setController] = useState(TableController)
  const [Filter, setFilter] = useState({
    search: '',
    disable_button: true,
  })
  const BookingTableHeader = [
    { label: '#' },
    { label: `${t('tableTitle.bookingNumber')}` },
    { label: `${t('tableTitle.clientName')}` },
    { label: `${t('tableTitle.date')}` },
    { label: `${t('tableTitle.time')}` },
    { label: `${t('tableTitle.amount')}` },
    // { label: `${t("tableTitle.status")}` },
  ]
  const BookingTableHeaderData = [
    { label: `${t('tableTitle.image')}` },
    { label: `${t('tableTitle.serviceName')}` },
    { label: `${t('tableTitle.price')} (${t('tableTitle.currencysymbols')})` },
    { label: `${t('tableTitle.quantity')}` },
    { label: `${t('tableTitle.finalPrice')}` },
    { label: `${t('tableTitle.status')}` },
  ]

  const BookingTabledata = [
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
    { BookingNumber: 'OEVENT2317', ServiceName: 'Service 01', Date: '15/06/2023', Time: '4:40 PM - 5:00 PM', VendorName: 'Jane Doe' },
  ]

  async function getBookinglist() {
    const { page, rowsPerPage, searchPage } = controller
    const { search } = Filter
    const keyword = search.trim()
    const payload = {
      searchText: searchPage && keyword ? keyword : undefined,
      page: page,
      count: rowsPerPage,
      // id: id,
      clientId: id,
      vendorId: user?.userInfo?._id,
    }

    setLoader(true)
    try {
      let response = await CLIENT_BOOKING_LIST(payload)
      setBookingData(response?.data)
      setTotalCount(response?.totalCount)
      setLoader(false)
    } catch (error) {
      setBookingData([])
      setTotalCount(0)
      setLoader(false)
    }
  }
  const handleChangeFilter = (event, disable = false) => {
    const { name, value } = event.target
    setFilter((pre) => ({ ...pre, disable_button: disable, [name]: value }))
  }
  const HandleSearch = () => {
    setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
  }
  const reset = (filterPopup) => {
    setController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null }))
    setFilter((prev) => ({ ...prev, search: '', disable_button: true, status: [] }))
    if (filterPopup) handleClickFilter()
  }
  const handleClickFilter = () => {
    setOpenModal((pre) => ({
      ...pre,
      data: null,
      filter: !pre?.filter,
    }))
  }
  const handlePagination = (obj) => {
    setController(obj)
  }
  const handleOpenModal = (type, data = null) => {
    setOpenModal((prev) => ({
      ...prev,
      data: data,
      [type]: true,
    }))
  }
  const handleClosedModal = (type) => {
    setOpenModal((pre) => ({
      ...pre,
      data: null,
      [type]: false,
    }))
  }
  useEffect(() => {
    getBookinglist()
  }, [controller])

  return {
    totalCount,
    controller,
    BookingTableHeader,
    BookingTabledata,
    handlePagination,
    setTotalCount,
    setTotalCount,
    setController,
    loader,
    bookigdata,
    handleOpenModal,
    handleClosedModal,
    openModal,
    BookingTableHeaderData,
    handleChangeFilter,
    HandleSearch,
    reset,
    Filter,
  }
}
